import React, { useState } from 'react';

const ColumnModal = ({ onSubmit, onClose }) => {
  const [columnName, setColumnName] = useState('');
  const [columnColor, setColumnColor] = useState('#ffffff'); // Color por defecto

  const handleSubmit = (e) => {
    e.preventDefault();
    if (columnName.trim()) {
      onSubmit({ name: columnName, color: columnColor });
      setColumnName('');
      setColumnColor('#ffffff');
      onClose();
    }
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Agregar Columna</h2>
        <form onSubmit={handleSubmit}>
          <label>
            Nombre de la columna:
            <input
              type="text"
              placeholder="Nombre de la columna"
              value={columnName}
              onChange={(e) => setColumnName(e.target.value)}
              required
            />
          </label>

          <label className='label-color'>
            Elegir Color:
            <input
              type="color"
              className='input-color'
              value={columnColor}
              onChange={(e) => setColumnColor(e.target.value)}
            />
          </label>

          <div className="modal-buttons">
            <button type="submit">Agregar</button>
            <button type="button" onClick={onClose}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ColumnModal;
